import { TagFilter } from 'gql-types';

import {
    DashboardContainer,
    RootEntity,
    isEpisodeOfCareContainer,
    isOrderContainer,
    isPatientContainer,
    isVisitContainer,
    isVisitRequestContainer,
} from './types';

/**
 * Injects a `hasTag` filter into the patient-level filters of a container,
 * nesting under `patient` for non-patient root entities.
 */
function injectPatientNestedTagFilter(
    container:
        | DashboardContainer<RootEntity.EPISODE_OF_CARE>
        | DashboardContainer<RootEntity.VISIT>
        | DashboardContainer<RootEntity.VISIT_REQUEST>
        | DashboardContainer<RootEntity.ORDER>,
    tagFilter: TagFilter,
): DashboardContainer<RootEntity> {
    return {
        ...container,
        tableConfig: {
            ...container.tableConfig,
            filters: {
                patient: { hasTag: tagFilter },
                AND: { ...container.tableConfig.filters },
            },
        },
    };
}

/**
 * Merges a `hasTag` filter into a container's filters based on entity type.
 * Returns a new container with the tag filter injected — does not mutate.
 */
export function injectTagFilter(
    container: DashboardContainer<RootEntity>,
    tagFilter: TagFilter,
): DashboardContainer<RootEntity> {
    if (isPatientContainer(container)) {
        return {
            ...container,
            tableConfig: {
                ...container.tableConfig,
                filters: {
                    hasTag: tagFilter,
                    AND: { ...container.tableConfig.filters },
                },
            },
        };
    }

    if (
        isEpisodeOfCareContainer(container) ||
        isVisitContainer(container) ||
        isVisitRequestContainer(container) ||
        isOrderContainer(container)
    ) {
        return injectPatientNestedTagFilter(container, tagFilter);
    }

    // Clinician (or any future entity without a patient field) — return unchanged.
    return container;
}
